<template>
  <h2 class="screen_out">UI UX 컨설팅 - 포트폴리오</h2>
  <article
    id="mainContent"
    :class="['content-article', 'content-service', `content_portfolio`]"
  >
    <h3 class="screen_out">UI UX 컨설팅 - 포트폴리오 본문</h3>
    <div class="wrap_content">
      <div class="wrap_iframe">
        <iframe
          src="https://embed.figma.com/deck/o3j77yZgTY1vYZ8sffoQpm/DKT-Creative?node-id=1-25&viewport=-136%2C-63%2C0.63&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&embed-host=share&client-id=VoFoMU4fBib5cdA3ATxTFU&footer=false"
          allowfullscreen
        ></iframe>
      </div>
    </div>
  </article>
</template>
<script setup>
import { GoogleAnalyticsTrackPage } from '~/utils/googleAnalytics.js';
useHead({
  title: 'DKT Creative Design showcase',
  meta: [
    {
      name: 'description',
      content:
        'This is design space at dk techin(a Kakao company). We create high-quality designs with a systematic design process, focusing on user-centered experiences.',
    },
    {
      property: 'og:title',
      content: 'DKT Creative Design showcase',
    },
    {
      property: 'og:description',
      content:
        'This is design space at dk techin(a Kakao company). We create high-quality designs with a systematic design process, focusing on user-centered experiences.',
    },
  ],
});

onMounted(() => {
  GoogleAnalyticsTrackPage('uiux_portfolio', 'uiux_portfolio_PV');
});
</script>
<style lang="scss" scoped>
.wrap_content {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background-color: #1e1e1e;
  z-index: 1000;
}
.wrap_iframe {
  box-sizing: border-box;
  max-width: 1664px;
  width: 100%;
  height: 100%;
  iframe {
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    border: 1px solid rgba(0, 0, 0, 0.1);
  }
}
</style>
